






















































































































import { Vue } from 'vue-property-decorator'
import {
  StockOutPlanServiceProxy,
  StockOutPlanMaterialServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'
import { getUserInfo } from '@/utils/auth'
import dayjs from 'dayjs'
const sopmsp = new StockOutPlanMaterialServiceProxy()
const sopsp = new StockOutPlanServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    scopedSlots: { customRender: 'actions' },
    ellipsis: true,
    width: 80
  },
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_plan_quantity',
    dataIndex: 'planNum',
    scopedSlots: { customRender: 'planNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_rea_plan_quantity',
    dataIndex: 'plannedNum',
    scopedSlots: { customRender: 'plannedNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_inventory_quantity',
    dataIndex: 'totalNum',
    scopedSlots: { customRender: 'totalNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_quantity_be_issued',
    dataIndex: 'toBeDeliveredNum',
    scopedSlots: { customRender: 'toBeDeliveredNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_demand_quantity',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true,
    width: 150
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      materialList: [], // 库位列表
      loading: false,
      count: 0
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deliveryDetail: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.dataSource = []
          sopsp.getPlanMaterialForStockOutPlan(this.deliveryDetail.planId).then((res) => {
            this.materialList = res
          })
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    canEdit(record) {
      return record.key.indexOf('edit') != -1
    },
    async getList() {
      const res = await sopmsp.listStockOutPlanMaterial(this.deliveryDetail.id)
      console.log(res)
      this.dataSource = res.map((item, index) => {
        let dat = { ...item }
        dat['key'] = index + 'edit'
        return dat
      })
    },
    dayjsTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    handleDelete(record) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== record.key)
    },
    addMaterial() {
      const { count, dataSource } = this
      const tenantId = getUserInfo().user_id
      const tenantName = getUserInfo().user_name
      const newData = {
        key: count + 'add',
        materialCode: '',
        materialName: '',
        planNum: 0,
        plannedNum: 0,
        totalNum: 0,
        toBeDeliveredNum: 0,
        requireNum: 0,
        maxrequireNum: 0,
        pickingUserId: tenantId,
        pickingUserName: tenantName
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    handleChangeCode(value, record) {
      const dda = this.dataSource.find((res) => res.materialId === value)
      if (dda) {
        this.$message.warning(this.$t('page_job_make_delivery_duplicate_material'))
        return
      }
      const newData = [...this.dataSource]
      let target = newData.find((item) => record.key === item.key)
      const material = this.materialList.find((res) => res.materialId === value)
      if (target) {
        target.materialId = material.materialId
        target.materialCode = material.materialCode
        target.materialName = material.materialName
        target.planNum = material.planNum
        target.plannedNum = material.plannedNum
        target.totalNum = material.totalNum
        target.toBeDeliveredNum = material.requireNum
        target.requireNum = material.requireNum
        target.maxrequireNum = material.requireNum
        this.dataSource = newData
        console.log(this.dataSource)
      }
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    close() {
      this.form.resetFields()
      this.dataSource = []
      this.$emit('close')
    },
    save() {
      const list = this.dataSource.filter((res) => res.materialId != '')
      if (list.length === 0) {
        this.$message.warning(this.$t('page_job_make_delivery_select_material'))
        return
      }
      const data: any = {
        id: this.deliveryDetail.id,
        list: list
      }
      this.loading = true
      sopsp.editStockOutPlan(data).then((res) => {
        this.close()
        this.loading = false
      })
    }
  }
})
